import { useCallback } from 'react';
import { AxiosRequestConfig } from 'axios';
import {
  OkResult,
  GetUserProfileResponse,
  UpdateUserNameRequest,
  UpdateUserLanguageRequest,
} from '@uniqkey-backend-organization-web/api-client';
import { useApiClients } from '../../contexts/APIClientsContext';
import { dataExtractor } from '../../helpers/apiClients';

const useUserAPI = () => {
  const { userAPIClient } = useApiClients();

  const getCurrentUser = useCallback(
    (options?: AxiosRequestConfig)
      : Promise<GetUserProfileResponse> => userAPIClient
      .apiV1UserCurrentUserProfileGet(options)
      .then(dataExtractor<GetUserProfileResponse>()),
    [userAPIClient],
  );

  const updateCurrentUserProfile = useCallback(
    (updateUserNameRequest?: UpdateUserNameRequest, options?: AxiosRequestConfig)
      : Promise<OkResult> => userAPIClient
      .apiV1UserUpdateCurrentUserProfilePut(updateUserNameRequest, options)
      .then(dataExtractor<OkResult>()),
    [userAPIClient],
  );

  const updateCurrentUserLanguage = useCallback(
    (updateUserLanguageRequest?: UpdateUserLanguageRequest, options?: AxiosRequestConfig)
      : Promise<OkResult> => userAPIClient
      .apiV1UserUpdateUserLanguagePut(updateUserLanguageRequest, options)
      .then(dataExtractor<OkResult>()),
    [userAPIClient],
  );

  return {
    updateCurrentUserProfile,
    updateCurrentUserLanguage,
    getCurrentUser,
  };
};

export default useUserAPI;
